export default __webpack_public_path__ + "media/src/assets/images/Delivery-a92806e577f71b87be0e2b0114345b7a.svg";